/**
 * Format a byte count as a human-readable size (e.g. "1.5 MB", "512 KB").
 *
 * Returns "0 B" for 0, negative, null, or undefined input so callers can
 * drop the result directly into UI without additional null guards. The
 * logarithm index is clamped to the highest available unit so very large
 * values render as "N GB" rather than producing NaN.
 */
export const formatFileSize = (bytes: number | null | undefined): string => {
  if (bytes == null || bytes <= 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(k)),
    sizes.length - 1,
  );
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
